import styled from 'styled-components'

export interface I_TypoProps {
    color?: string
    fontWeight?: string
    opacity?: number
    lineHeight?: string
    captialize?: string
    textTransform?: string
    textAlign?: string
    maxWidth?: string
    minWidth?: string
    padding?: string
    margin?: string
}

export const Text = styled.p<I_TypoProps>`
  font-family: 'TomatoGrotesk';
  font-weight: ${(props) => props.fontWeight || 400};
  line-height: 20px;
  max-width: ${(props) => props.maxWidth};
  min-width: ${(props) => props.minWidth};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  color: ${(props) => props.color};
  opacity: ${(props) => props.opacity};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin || 0};

`
export const Subtitle = styled.p<I_TypoProps>`
  font-family: 'TomatoGrotesk';
  font-weight: ${(props) => props.fontWeight || 500};
  line-height: 24px;
  max-width: ${(props) => props.maxWidth};
  min-width: ${(props) => props.minWidth};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  color: ${(props) => props.color};
  opacity: ${(props) => props.opacity};
  margin: ${(props) => props.margin || 0};
`
export const WarningText = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${(props) => props.fontWeight || 500};
  color: #FF9B26;
`

export const BodyRegular = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${(props) => props.fontWeight || 500};
`

export const SubtitleMedium = styled(Subtitle)`
  font-size: 28px;
  font-weight: ${(props) => props.fontWeight || 700};
  line-height: 36px;

`
export const BodySemibold = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${(props) => props.fontWeight || 600};
`

export const HealLine2 = styled(Text)`
  font-size: 56px;
  line-height: 64px;
  font-weight: ${(props) => props.fontWeight || 700};
`

export const HealLine3 = styled(Text)`
  font-size: 32px;
  line-height: 40px;
  font-weight: ${(props) => props.fontWeight || 700};
`